// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"f6fde4a1","583":"9312eed3"}[chunkId] + ".chunk.js";
};